import { createRouter, createWebHistory } from 'vue-router'
import Dashboard from '../views/Dashboard.vue'
import KnowledgeBase from '../views/KnowledgeBase.vue'
import KnowledgeBaseDetail from '../views/KnowledgeBaseDetail.vue'
import WeightData from '../views/WeightData.vue'
import NotificationCenter from '../views/NotificationCenter.vue'
import PatientManagement from '../views/PatientManagement.vue'

const routes = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      title: '控制面板',
      icon: 'Monitor',
      roles: ['admin', 'organization']
    }
  },
  // 患者管理
  {
    path: '/patient',
    name: 'PatientMenu',
    meta: {
      title: '患者管理',
      icon: 'User',
      roles: ['admin', 'doctor', 'organization']
    },
    children: [
      {
        path: 'patients',
        alias: '/patients',
        name: 'PatientManagement',
        component: PatientManagement,
        meta: {
          title: '患者列表',
          icon: 'User',
          roles: ['admin', 'doctor', 'organization']
        }
      },
      {
        path: 'option-data/:userId',
        alias: '/patient/option-data/:userId',
        name: 'PatientOptionData',
        component: () => import('../views/PatientOptionData.vue'),
        meta: {
          title: '智能选项数据',
          icon: 'Document',
          roles: ['admin', 'doctor', 'organization'],
          hidden: true
        }
      },
      {
        path: 'patient-scheduling',
        alias: '/patient-scheduling',
        name: 'PatientScheduling',
        component: () => import('../views/PatientScheduling.vue'),
        meta: {
          title: '患者排班管理',
          icon: 'Calendar',
          roles: ['admin', 'doctor', 'organization']
        }
      },
      {
        path: 'questionnaire',
        alias: '/questionnaire',
        name: 'QuestionnaireManagement',
        component: () => import('../views/QuestionnaireManagement.vue'),
        meta: {
          title: '问卷管理',
          icon: 'List',
          roles: ['admin', 'doctor', 'organization']
        }
      }
    ]
  },
  // 健康数据
  {
    path: '/health-data',
    name: 'HealthDataMenu',
    meta: {
      title: '健康数据',
      icon: 'TrendCharts',
      roles: ['admin', 'doctor', 'organization']
    },
    children: [
      {
        path: 'weight-new-list',
        alias: '/weight-new-list',
        name: 'WeightNewListInfo',
        component: () => import('../views/WeightNewListInfo.vue'),
        meta: {
          title: '体重数据',
          icon: 'TrendCharts',
          roles: ['admin', 'doctor', 'organization']
        }
      },
      {
        path: 'activity-list',
        alias: '/activity-list',
        name: 'ActivityList',
        component: () => import('../views/ActivityList.vue'),
        meta: {
          title: '干体重活动',
          icon: 'List',
          roles: ['admin', 'doctor', 'organization']
        }
      },
      {
        path: 'pressure',
        alias: '/pressure',
        name: 'BloodPressureData',
        component: () => import('../views/BloodPressureData.vue'),
        meta: {
          title: '血压数据',
          icon: 'TrendCharts',
          roles: ['admin', 'doctor', 'organization']
        }
      },
      {
        path: 'weight',
        alias: '/weight',
        name: 'WeightData',
        component: WeightData,
        meta: {
          title: '个人体重数据',
          icon: 'TrendCharts',
          roles: ['admin', 'doctor', 'organization'],
          hidden: true
        }
      }
    ]
  },
  // 医生管理
  {
    path: '/doctor',
    name: 'DoctorMenu',
    meta: {
      title: '医生管理',
      icon: 'UserFilled',
      roles: ['admin']
    },
    children: [
      {
        path: 'doctors',
        alias: '/doctors',
        name: 'DoctorManagement',
        component: () => import('../views/DoctorManagement.vue'),
        meta: {
          title: '医生账号管理',
          icon: 'UserFilled',
          roles: ['admin']
        }
      }
    ]
  },
  // 护士管理
  {
    path: '/nurses',
    alias: '/nurse',
    name: 'NurseManagement',
    component: () => import('../views/NurseManagement.vue'),
    meta: {
      title: '护士管理',
      icon: 'FirstAidKit',
      roles: ['admin']
    }
  },
  // 机构权限
  {
    path: '/org-access',
    name: 'OrgAccessMenu',
    meta: {
      title: '机构权限',
      icon: 'OfficeBuilding',
      roles: ['admin']
    },
    children: [
      {
        path: 'organization',
        alias: '/organization',
        name: 'OrganizationManagement',
        component: () => import('../views/Organization.vue'),
        meta: {
          title: '机构信息管理',
          icon: 'OfficeBuilding',
          roles: ['admin']
        }
      },
      {
        path: 'organization-managers',
        alias: '/organization/managers',
        name: 'OrganizationManagers',
        component: () => import('../views/OrganizationManager.vue'),
        meta: {
          title: '机构管理员',
          icon: 'UserFilled',
          roles: ['admin']
        }
      },
      {
        path: 'admin-management',
        alias: '/admin-management',
        name: 'AdminManagement',
        component: () => import('../views/AdminManagement.vue'),
        meta: {
          title: '系统管理员',
          icon: 'Setting',
          roles: ['admin']
        }
      }
    ]
  },
  // 知识库管理
  {
    path: '/knowledge-menu',
    name: 'KnowledgeMenu',
    meta: {
      title: '知识库管理',
      icon: 'Document',
      roles: ['admin', 'doctor']
    },
    children: [
      {
        path: 'knowledge',
        alias: '/knowledge',
        name: 'KnowledgeBase',
        component: KnowledgeBase,
        meta: {
          title: 'AI知识库管理',
          icon: 'Document',
          roles: ['admin', 'doctor']
        }
      },
      {
        path: 'approval',
        alias: '/approval',
        name: 'ApprovalRecords',
        component: () => import('../views/ApprovalRecords.vue'),
        meta: {
          title: '知识库审核',
          icon: 'DocumentChecked',
          roles: ['admin', 'doctor']
        }
      },
      {
        path: 'knowledge/:id',
        alias: '/knowledge/:id',
        name: 'KnowledgeBaseDetail',
        component: KnowledgeBaseDetail,
        meta: {
          title: '知识库详情',
          icon: 'Document',
          hidden: true,
          roles: ['admin', 'doctor']
        }
      }
    ]
  },
  // 商城管理
  {
    path: '/mall',
    name: 'MallManagement',
    meta: {
      title: '商城管理',
      icon: 'ShoppingCart',
      roles: ['admin']
    },
    children: [
      {
        path: 'vip-tags',
        name: 'VipTags',
        component: () => import('../views/VipTags.vue'),
        meta: {
          title: '商品分类',
          icon: 'Collection',
          roles: ['admin']
        }
      },
      {
        path: 'vip-shop',
        name: 'VipShop',
        component: () => import('../views/VipShop.vue'),
        meta: {
          title: '商品管理',
          icon: 'ShoppingCart',
          roles: ['admin']
        }
      },
      {
        path: 'vip-orders',
        name: 'VipOrderList',
        component: () => import('../views/VipOrderList.vue'),
        meta: {
          title: '订单管理',
          icon: 'Document',
          roles: ['admin']
        }
      }
    ]
  },
  // 金币管理（仅总管理员）
  {
    path: '/coin',
    name: 'CoinMenu',
    meta: {
      title: '金币管理',
      icon: 'Coin',
      roles: ['admin']
    },
    children: [
      {
        path: 'accounts',
        alias: '/coin-accounts',
        name: 'CoinAccountList',
        component: () => import('../views/CoinAccountList.vue'),
        meta: {
          title: '用户金币列表',
          icon: 'User',
          roles: ['admin']
        }
      },
      {
        path: 'withdraw',
        alias: '/coin-withdraw',
        name: 'CoinWithdraw',
        component: () => import('../views/CoinWithdraw.vue'),
        meta: {
          title: '提现审核',
          icon: 'DocumentChecked',
          roles: ['admin']
        }
      }
    ]
  },
  // 广告位管理
  {
    path: '/ad-banner',
    name: 'AdBannerManagement',
    component: () => import('../views/AdBanner.vue'),
    meta: {
      title: '广告位管理',
      icon: 'Picture',
      roles: ['admin']
    }
  },
  // 通知中心
  {
    path: '/notification',
    name: 'NotificationCenter',
    component: NotificationCenter,
    meta: {
      title: '通知中心',
      icon: 'Check',
      roles: ['admin']
    }
  },
  // 个人信息（隐藏）
  {
    path: '/user-info',
    name: 'UserInfo',
    component: () => import('../views/UserInfo.vue'),
    meta: {
      title: '个人信息',
      icon: 'User',
      hidden: true,
      roles: ['admin', 'doctor']
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 暴露原始路由数组，供菜单构建使用（带 children 结构）
router.menuRoutes = routes

// 路由守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = `${to.meta.title} - 肾数科技后台管理系统`
  }
  next()
})

export default router 
